import GUI from "lil-gui";

export default class Debug {
  ui: GUI | null;
  constructor() {
    this.ui = window.location.hash === "#debug" ? new GUI() : null;
  }
}
